import { ProductType } from 'frontend/enums'
import { Product, Program } from 'frontend/types'

export const isSingleProduct = (productType: ProductType, product: Product) => {
  return !(product as Program).seriesId && productType === ProductType.PROGRAM
}
